import { renderIcon } from '../../SvgIcon.esm.js';

/******************************************************
 * This file was created by scripts/generate.js as part
 * of the build process. Do not edit this file directly.
 ******************************************************/
var iconType = {
  viewBox: "0 0 24 24",
  paths: [{
    d: "M17.17 2C18.73 2 20 3.27 20 4.83V13h1c.55 0 1 .45 1 1v5c0 1.1-.9 2-2 2 0 .55-.45 1-1 1H5c-.55 0-1-.45-1-1-1.1 0-2-.9-2-2v-5c0-.55.45-1 1-1h2v-.75c0-1.24 1-2.24 2.24-2.25.35 0 .69.08 1 .23.26.12.5.29.69.5l1.4 1.55c.25.27.52.51.82.72H18V4.83c0-.46-.37-.83-.83-.83-.22 0-.43.09-.58.24l-1.25 1.25c.04.17.07.33.07.51 0 .4-.12.77-.32 1.08l-2.76-2.76c.31-.2.68-.32 1.08-.32.18 0 .35.03.51.08l1.25-1.25c.53-.53 1.25-.83 2-.83zM7 5c1.1046 0 2 .8954 2 2s-.8954 2-2 2-2-.8954-2-2 .8954-2 2-2z",
    fillRule: "evenodd"
  }],
  circles: []
};
var BathtubIcon = function BathtubIcon(props) {
  return renderIcon(props, iconType);
};
export { BathtubIcon };